module.exports = __webpack_public_path__ + "3d-printer-main.png?271493a6db2131a46a2e6d7d63abbe3b";